import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'
import PVHeader from './pvHeader.js'

export default class RenderConsent extends React.Component{

	onButtonClick = (e) => {
		const {
			pvEndData,
			handleConsent,
			handleReply,
			pvAnswer,
			client,
			userID,
			identifier
		} = this.props
		const sendButton = pvEndData.screen_1.button_1
		let currentClassList = e.currentTarget.classList
		currentClassList.add('button--active')
		let pvDOM = document.getElementsByClassName('pv')[0].classList
		pvDOM.add('pv--no-click')
		const topic = `users/${userID}/apps/tablets/${identifier}/pv`

		if(sendButton === e.currentTarget.getAttribute('name')){
			client.publish(topic, JSON.stringify(pvAnswer), {qos:2, retain:false})
			handleConsent()
		} else {
			handleReply()
		}
	}

	componentDidMount(){
		setTimeout(()=>{
			document.getElementsByClassName('pv')[0].classList.remove('pv--no-click')
		},900)
	}

	render(){
		const {
			pvEndData,
			lang,
		} = this.props

		const consentData = pvEndData.screen_1
		const text = consentData.text_2
		const subtext = consentData.text_3
		const button1 = consentData.button_1
		const button2 = consentData.button_2

		return(
			<div className='pv pv-consent pv--no-click'>
				<PVHeader
					pvEndData={pvEndData}
					lang={lang}
				/>
				<CSSTransitionGroup
					transitionName="pv-background"
					transitionAppear={true}
					transitionAppearTimeout={1100}
					transitionEnterTimeout={1100}
					transitionLeaveTimeout={1100}>
					<div className='questionContainerPR'>
						<div className='text'>{text}</div>
						<div className='subtext'>{subtext}</div>
						<div className='optionsPR'>
							<div className='pv-button pv-button--large' name={button1} onClick={this.onButtonClick}>{button1}</div>
							<div className='pv-button pv-button--large' name={button2} onClick={this.onButtonClick}>{button2}</div>
						</div>
					</div>
				</CSSTransitionGroup>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/presentationReferral/subcomponents/renderConsent.js